import Config from "../config.js";
import { createRequestOptions } from "./utils";
import { get } from "lodash";

export default () => {
  return Object.freeze({
    getUserInbox: async (userId) => {
      const options = createRequestOptions({ userId });

      const result = await fetch(
        Config.commServerUrl + "/GetUserMessagesCount",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    getMessagesBetweenUsers: async (userId, userId2) => {
      const options = createRequestOptions({ userId, userId2 });

      const result = await fetch(
        Config.commServerUrl + "/GetMessagesBetweenUsers",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },

    setMessageToViewed: async (messageId) => {
        const options = createRequestOptions({messageId});
  
        const result = await fetch(
          Config.commServerUrl + "/SetMessageToViewed",
          options
        );
        const response = await result.json();
  
        return get(response, "response");
      },
    setMessageToArchived: async (messageId) => {
        const options = createRequestOptions({messageId});
  
        const result = await fetch(
          Config.commServerUrl + "/SetMessageToArchived",
          options
        );
        const response = await result.json();
  
        return get(response, "response");
      },
  });
};



// WEBPACK FOOTER //
// ./src/services/messages.js